import { render, staticRenderFns } from "./acta-conformacion1.1.6.vue?vue&type=template&id=0bf9067c&"
import script from "./acta-conformacion1.1.6.vue?vue&type=script&lang=js&"
export * from "./acta-conformacion1.1.6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports